import type { Feature } from '@luna/gatekeeper';

export const dynamicCurrencyConversion: Feature = {
    enabled: true,
    _description: 'Enables display of the dynamic currency conversion card and focus page',
};
